import { render, staticRenderFns } from "./BidList.vue?vue&type=template&id=13e5084f&"
import script from "./BidList.vue?vue&type=script&lang=js&"
export * from "./BidList.vue?vue&type=script&lang=js&"
import style0 from "./BidList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports